import { render, staticRenderFns } from "./ProjectPlatformGoogleAssistant.vue?vue&type=template&id=55c9194a"
import script from "./ProjectPlatformGoogleAssistant.vue?vue&type=script&lang=ts"
export * from "./ProjectPlatformGoogleAssistant.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports